import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import RequireSignupFinishedMiddleware from 'middlewares/RequireSignupFinishedMiddleware'
import RequirePhysicianOrAncillaryOrDemoMiddleware from 'middlewares/RequirePhysicianOrAncillaryOrDemoMiddleware'
import { steps as newReferralSteps } from 'mixins/ReferralsNewPageMixin'

export default [
    ...['received', 'made'].map((type) => ({
        path: `/referrals/pool/${type}/:id`,
        name: `referrals.${type}.pool.show`,
        view: 'referrals/pool/ReferralPoolShow',
        default: { params: { type } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    })),
    {
        path: '/referrals-pool/:poolId/location/:locationId',
        name: 'referrals.pool.propose.time',
        view: 'referrals/pool/ReferralPoolProposeTime',
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    },
    {
        path: '/referrals-pool/new',
        name: 'pool.new',
        redirect: { name: `pool.new.${newReferralSteps[0].path}` },
    },
    ...newReferralSteps.map((step) => ({
        path: `/referrals-pool/new/${step.path}`,
        name: `pool.new.${step.path}`,
        view: `referrals/new/${step.view}`,
        default: { query: { limit: 6 }, params: { step: step.path } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    })),
]
